/**
 * /pos-bkp — backup do catálogo das pós-graduações FORA de ação.
 *
 * Mantido navegável (noindex) para conferência durante as ações promocionais,
 * quando /pos passa a exibir a LP da campanha.
 */
import { createFileRoute } from "@tanstack/react-router";

import { PosCatalogoPage } from "@/components/lps/PosCatalogoPage";

export const Route = createFileRoute("/pos-bkp")({
  head: () => ({
    meta: [
      { title: "Pós-Graduações FEO (backup)" },
      {
        name: "description",
        content: "Versão de backup do catálogo das 6 pós-graduações da FEO, sem oferta de campanha.",
      },
      { property: "og:title", content: "Pós-Graduações FEO (backup)" },
      { property: "og:description", content: "Catálogo das pós-graduações da FEO fora de ação promocional." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <PosCatalogoPage />,
});
